import type { ApiClient } from './client'
import type {
  SyncApi,
  SyncDigest,
  SyncOperationRequest,
  SyncPullResult,
  SyncPushResult,
} from '@/offline/syncEngine'

export class HttpSyncApi implements SyncApi {
  private readonly api: ApiClient

  constructor(api: ApiClient) {
    this.api = api
  }

  push(request: { deviceId: string; operations: SyncOperationRequest[] }): Promise<SyncPushResult> {
    return this.api.post<SyncPushResult>('/sync/push', request)
  }

  pull(request: {
    deviceId: string
    groupCursors: Record<string, number>
    maxEntries: number
  }): Promise<SyncPullResult> {
    return this.api.post<SyncPullResult>('/sync/pull', request)
  }

  async acknowledge(groupCursors: Record<string, number>): Promise<void> {
    await this.api.post('/sync/ack', groupCursors)
  }

  digest(): Promise<SyncDigest[]> {
    return this.api.get<SyncDigest[]>('/sync/digest')
  }
}
